import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHasPermission } from "../../contexts/auth";
import styles from "./invoices.module.css";

const BASE_PATH = "/invoices";
const PURCHASE_PATH = `${BASE_PATH}/purchase`;

export const Invoices = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const canViewSalesInvoices = useHasPermission("invoice.view_invoice");
  const canViewPurchaseInvoices = useHasPermission(
    "invoice.view_purchaseinvoice"
  );

  const tabs: { key: string; label: string; path: string }[] = [];
  if (canViewSalesInvoices) {
    tabs.push({ key: "sales", label: t("Sales invoices"), path: BASE_PATH });
  }
  if (canViewPurchaseInvoices) {
    tabs.push({
      key: "purchase",
      label: t("Purchase invoices"),
      path: PURCHASE_PATH,
    });
  }

  const activeKey = location.pathname.startsWith(PURCHASE_PATH)
    ? "purchase"
    : "sales";
  const tabValue = tabs.some((tab) => tab.key === activeKey) ? activeKey : false;

  return (
    <Box className={styles.container}>
      <Tabs value={tabValue}>
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            value={tab.key}
            label={tab.label}
            onClick={() => navigate(tab.path)}
          />
        ))}
      </Tabs>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
